<template>
  <div>
    <Permissions />
    <br>
    <br>
    <UserCrud/>
  </div>
</template>

<script>
import Permissions from '@/modules/CA_SP/components/admin/Permissions.vue';
import UserCrud from '@/modules/CA_SP/components/admin/UserCrud.vue';
export default {
  components:{ UserCrud, Permissions },
};
</script>
